import { getGroupAuthType } from "@/utils/authToken";
import { httpAuth2 } from "@/api/auth";

import { GROUP_AUTH_HEADER_NAME } from "../constants";

export const surveyRequests = {
  check_survey: async ({ context, data } = {}) => {
    return httpAuth2
      .post("/v1/survey/check_nps_survey", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },
  submit_survey: async ({ context, data } = {}) => {
    return httpAuth2
      .post("/v2/survey/nps_survey", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },
};
